"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ["Consultant", "End-user", "Other", "Partner"];
exports.default = _default;
//# sourceMappingURL=prospect_type.js.map